import { render, staticRenderFns } from "./TableFilterColumnsWrapper.vue?vue&type=template&id=283d5177&"
import script from "./TableFilterColumnsWrapper.vue?vue&type=script&lang=js&"
export * from "./TableFilterColumnsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TableFilterColumnsWrapper.vue?vue&type=style&index=0&id=283d5177&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports